"use client";
import AddIcon from "@/components/atoms/svg/icons/AddIcon";
import Earth from "@/components/atoms/svg/icons/Earth";
import Scintilla from "@/components/atoms/svg/icons/Scintilla";
import AIModal from "@/components/atoms/AIModal/AIModal";
import { Button } from "@/components/ui/button";

import { AI_MODALS } from "@/constants/AI";
import Link from "next/link";
import Circuit from "@/components/atoms/svg/icons/Circuit";
import useProfileStore from "@/stores/profile";

export default function HeroSection() {
  const token = useProfileStore((state) => state.token);

  return (
    <div className="w-full overflow-hidden relative h-[660px] pt-[72px] bg-[#BCA999] px-2 sm:px-4 pb-10 xl:px-0 xl:pb-0">
      <div className="absolute left-0 top-0 z-0 h-[calc(100%+6px)] aspect-[1.2/1]">
        <div className="relative size-full before:absolute before:inset-0 before:z-0 before:bg-gradient-to-r before:from-[#BCA999] before:to-white before:bg-[length:200%_100%] before:animate-gradient">
          {/* <Image
            className="object-contain z-[1] select-none"
            src={VECTOR_HERO}
            alt="vector_hero"
            fill
          /> */}
          <Circuit className="absolute z-[1]" />
        </div>
      </div>
      <div className="relative max-w-[1200px] mx-auto h-full grid grid-rows-2 grid-cols-1 lg:grid-cols-2 lg:grid-rows-1">
        <div className="lg:mt-[94px] lg:mb-[150px] lg:mr-[75px] xl:mr-[149px] space-y-2 min-[361px]:space-y-5 md:space-y-8 lg:space-y-10">
          <div className="space-y-2 min-[361px]:space-y-3 md:space-y-6">
            <h3 className="text-2xl min-[451px]:text-4xl sm:text-5xl font-medium leading-normal sm:leading-h3 tracking-normal sm:tracking-h3 text-white">
              Revolutionize your experience
            </h3>
            <p className="text-white/60 text-base min-[451px]:text-lg sm:text-xl font-normal leading-normal sm:leading-body-l tracking-body-m">
              Create and customize your AI Agent effortlessly Build smarter AI
              in minutes for free.
            </p>
          </div>
          <div className="flex flex-col min-[451px]:flex-row min-[451px]:items-center gap-2 min-[451px]:gap-4">
            <Link href={token ? "/create" : "/login"} passHref>
              <Button
                className="!text-white rounded-full !bg-white/[0.14] border-white/[0.18] font-medium text-xs min-[361px]:text-sm leading-normal min-[361px]:leading-caption-l tracking-normal min-[361px]:tracking-caption-l h-auto min-h-8 min-[361px]:min-h-10 w-full"
                variant="outline"
                type="button"
              >
                <AddIcon className="fill-white/60" />
                Create AI Agent
              </Button>
            </Link>
            <Link href="/explore" passHref>
              <Button
                className="btn-default text-sm leading-normal min-[361px]:leading-caption-l tracking-normal min-[361px]:tracking-caption-l !min-h-8 min-[361px]:!min-h-10 w-full"
                type="button"
              >
                <Earth />
                Explore AI Agents
              </Button>
            </Link>
          </div>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              {AI_MODALS.map((modal) => (
                <AIModal
                  className="size-6 min-[361px]:size-7 min-[451px]:size-8 bg-white/70 [&>svg]:size-[12px] min-[361px]:[&>svg]:size-[15px] min-[451px]:[&>svg]:size-[18px]"
                  key={modal.id}
                  {...modal}
                />
              ))}
            </div>
            <p className="text-white/60 leading-none tracking-normal min-[451px]:tracking-caption-l min-[451px]:leading-caption-l text-xs min-[451px]:text-sm font-normal">
              Power up with AI alongside 100M+ users.
            </p>
          </div>
        </div>
        <div className="lg:mt-[34px] lg:mb-[74px] lg:mr-0 xl:mr-[53px] flex">
          <div className="aspect-[1.14/1] max-h-full lg:aspect-auto lg:w-full m-auto lg:m-0 relative flex justify-center items-center">
            <video
              preload="none"
              autoPlay
              loop
              muted
              playsInline
              className="size-full object-cover scale-x-[-1] mix-blend-darken select-none"
            >
              <source src="/video/donut.webm" type="video/webm" />
            </video>
            <Scintilla className="absolute w-1/2 aspect-square" />
          </div>
        </div>
      </div>
    </div>
  );
}
